import { render, staticRenderFns } from "./urldata.vue?vue&type=template&id=3c839816&scoped=true&"
import script from "./urldata.vue?vue&type=script&lang=js&"
export * from "./urldata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c839816",
  null
  
)

export default component.exports